var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.qscData)?_c('div',{staticClass:"flex_col scroll"},[_c('QSCStoreInfo',{attrs:{"data":_vm.qscData.store}}),_c('QSCInspectionLists',{attrs:{"data":_vm.qscData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }